import { __decorate, __extends } from "tslib";
import { inject, observer } from 'mobx-react';
import React from 'react';
import { list } from '../../api/extras';
import { Button } from '../../components/Button';
import { ExtraItem } from '../../components/ExtraItem';
import { SpinnerBlock } from '../../components/Spinner';
import { ExtrasDetailsModal } from './ExtrasDetailsModal';
import S from './extras.styl';
var ExtrasView = /** @class */ (function (_super) {
    __extends(ExtrasView, _super);
    function ExtrasView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            extras: [],
            loading: false,
            showCreateModal: false,
        };
        _this.onUpdate = function () {
            _this.fetchData();
        };
        _this.createAction = function () {
            _this.setState({
                editExtra: undefined,
                showCreateModal: true,
            });
        };
        _this.onCloseAdd = function () {
            _this.setState({
                showCreateModal: false,
            });
        };
        _this.isUpdatedAdd = function () {
            _this.setState({
                showCreateModal: false,
            });
            _this.fetchData();
        };
        _this.isEditClicked = function (extra) {
            _this.setState({
                editExtra: extra,
                showCreateModal: true,
            });
        };
        return _this;
    }
    ExtrasView.prototype.componentDidMount = function () {
        var store = this.props.store;
        if (store) {
            this.fetchData();
        }
    };
    ExtrasView.prototype.fetchData = function () {
        var _this = this;
        this.setState({ loading: true });
        list().then(function (result) {
            _this.setState({
                loading: false,
                extras: (result === null || result === void 0 ? void 0 : result.items) || [],
            });
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
    };
    ExtrasView.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var i18n = props.store.i18n;
        var _a = this.state, loading = _a.loading, extras = _a.extras;
        return (React.createElement("div", { className: S.extrasView },
            React.createElement("h1", { className: S.extrasTitle }, i18n.sideBarExtras),
            React.createElement("hr", { className: S.extrasSeparator }),
            React.createElement("div", { className: S.extrasHeaderActions },
                React.createElement(Button, { className: "primaryButton " + S.addButton, type: "button", onClick: this.createAction }, i18n.actionCreate)),
            React.createElement("div", { className: S.extrasMainBox }, loading ?
                React.createElement(SpinnerBlock, null)
                :
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: S.extrasHeader },
                            React.createElement("div", { className: S.tableCell + " imageCell" }, i18n.mediasItemImage),
                            React.createElement("div", { className: S.tableCell }, i18n.modelsItemTitle),
                            React.createElement("div", { className: S.action }, i18n.modelsAction)),
                        React.createElement("div", { className: S.extrasUserList }, extras.map(function (extra, i) { return (React.createElement(ExtraItem, { key: i, extra: extra, isUpdated: _this.onUpdate, isEditClicked: _this.isEditClicked })); })))),
            this.state.showCreateModal &&
                React.createElement(ExtrasDetailsModal, { onClose: this.onCloseAdd, isUpdated: this.isUpdatedAdd, extra: this.state.editExtra })));
    };
    ExtrasView = __decorate([
        inject('store'),
        observer
    ], ExtrasView);
    return ExtrasView;
}(React.Component));
export { ExtrasView };
